const topics = [
  
    // 5.B.1.1 — Traditions / expression → identity
    { title: "Freedom Quilt", slug: "freedomquilt", standardNumber: "5.B.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Jazz / Music of America", slug: "jazzmusicofamerica", standardNumber: "5.B.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Native Contributions", slug: "nativecontributions", standardNumber: "5.B.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.B.1.2 — Values/beliefs → identity
    { title: "Native Contributions", slug: "nativecontributions", standardNumber: "5.B.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "As Americans", slug: "asamericans", standardNumber: "5.B.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "People", slug: "people", standardNumber: "5.B.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.B.1.1 / 5.B.1.2 — additional matches
    { title: "What is Belief", slug: "whatisbelief", standardNumber: "5.B.1.1/5.B.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "What is Culture", slug: "whatisculture", standardNumber: "5.B.1.1/5.B.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Love Our Country", slug: "loveourcountry", standardNumber: "5.B.1.1/5.B.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.C&G.1 — Structure & Function of U.S. Government
    { title: "Governments", slug: "governments", standardNumber: "5.C&G.1.1/5.C&G.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.C&G.1.1 — Roles/responsibilities of branches
    { title: "The Government", slug: "thegovernment", standardNumber: "5.C&G.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.C&G.1.2 — Branches protect freedom/equality/justice
    { title: "The Government", slug: "thegovernment", standardNumber: "5.C&G.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.C&G.2 — Rights of Citizens
    { title: "Responsible Citizen", slug: "responsiblecitizen", standardNumber: "5.C&G.2.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Pledge", slug: "pledge", standardNumber: "5.C&G.2.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.C&G.2.1 / 5.C&G.2.2 — advocacy & rights exemplars
    { title: "Susan B Anthony", slug: "susanbanthony", standardNumber: "5.C&G.2.1/5.C&G.2.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Sojourner Truth", slug: "sojournertruth", standardNumber: "5.C&G.2.1/5.C&G.2.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Eleanor Roosevelt", slug: "eleanorroosevelt", standardNumber: "5.C&G.2.1/5.C&G.2.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Ruby Bridges", slug: "rubybridges", standardNumber: "5.C&G.2.1/5.C&G.2.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.E.1 — Economic Decisions & Growth
    { title: "Producer", slug: "producer", standardNumber: "5.E.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Trade", slug: "trade", standardNumber: "5.E.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    { title: "Wants & Choices", slug: "wantsandchoices", standardNumber: "5.E.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    { title: "Producer", slug: "producer", standardNumber: "5.E.1.3", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    { title: "Trade", slug: "trade", standardNumber: "5.E.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Barter", slug: "barter", standardNumber: "5.E.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.E.1.1–5.E.1.4 — additional matches
    { title: "Scarcity Impacts", slug: "scarcityimpacts", standardNumber: "5.E.1.1-5.E.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Goods & Services", slug: "goodsandservices", standardNumber: "5.E.1.1-5.E.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Entrepreneurs", slug: "entrepreneurs", standardNumber: "5.E.1.1-5.E.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.E.2 — Personal Financial Decisions
    { title: "Wants & Choices", slug: "wantsandchoices", standardNumber: "5.E.2.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    // (5.E.2.2 had “no direct song yet” per your note)
    { title: "Wants & Choices", slug: "wantsandchoices", standardNumber: "5.E.2.3", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.G.1 — Geography & U.S. Development
    { title: "Surviving Seasons", slug: "survivingseasons", standardNumber: "5.G.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    { title: "They Built America", slug: "theybuiltamerica", standardNumber: "5.G.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Underground Railroad", slug: "undergroundrailroad", standardNumber: "5.G.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    { title: "They Built America", slug: "theybuiltamerica", standardNumber: "5.G.1.3", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    { title: "They Built America", slug: "theybuiltamerica", standardNumber: "5.G.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.G.1.2 / 5.G.1.3 / 5.G.1.4 — additional matches
    { title: "Trail of Tears", slug: "trailoftears", standardNumber: "5.G.1.2/5.G.1.3/5.G.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Slave Trade", slug: "slavetrade", standardNumber: "5.G.1.2/5.G.1.3/5.G.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "History’s Truth", slug: "historystruth", standardNumber: "5.G.1.2/5.G.1.3/5.G.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.H.1 — People, events, ideas shaping U.S.
    { title: "People", slug: "people", standardNumber: "5.H.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Native Contributions", slug: "nativecontributions", standardNumber: "5.H.1.1", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    { title: "People", slug: "people", standardNumber: "5.H.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Native Contributions", slug: "nativecontributions", standardNumber: "5.H.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.H.1.1 / 5.H.1.2 — exemplar figures
    { title: "George Washington Carver", slug: "georgewashingtoncarver", standardNumber: "5.H.1.1/5.H.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Eleanor Roosevelt", slug: "eleanorroosevelt", standardNumber: "5.H.1.1/5.H.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Susan B Anthony", slug: "susanbanthony", standardNumber: "5.H.1.1/5.H.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Sojourner Truth", slug: "sojournertruth", standardNumber: "5.H.1.1/5.H.1.2", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.H.1.3 — Revolution/reform/resistance
    { title: "They Built America", slug: "theybuiltamerica", standardNumber: "5.H.1.3", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "As Americans", slug: "asamericans", standardNumber: "5.H.1.3", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.H.1.4 — Impact of major conflicts/events
    { title: "They Built America", slug: "theybuiltamerica", standardNumber: "5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "People", slug: "people", standardNumber: "5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.H.1.3 / 5.H.1.4 — additional matches
    { title: "Colonial Williamsburg", slug: "colonialwilliamsburg", standardNumber: "5.H.1.3/5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Paul Revere’s Ride", slug: "paulreveresride", standardNumber: "5.H.1.3/5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "The Boston Tea Party", slug: "thebostonteaparty", standardNumber: "5.H.1.3/5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "The Intolerable Acts", slug: "theintolerableacts", standardNumber: "5.H.1.3/5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "The Quartering Act", slug: "thequarteringact", standardNumber: "5.H.1.3/5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "The Boston Massacre", slug: "thebostonmassacre", standardNumber: "5.H.1.3/5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Resistance and Reform", slug: "resistanceandreform", standardNumber: "5.H.1.3/5.H.1.4", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
    // 5.H.1.6 — Symbols & traditions
    { title: "Pledge", slug: "pledge", standardNumber: "5.H.1.6", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "American Flag", slug: "americanflag", standardNumber: "5.H.1.6", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "Love Our Country", slug: "loveourcountry", standardNumber: "5.H.1.6", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
    { title: "NC State Flag", slug: "ncstateflag", standardNumber: "5.H.1.6", description: "", gameType: "multipleChoice", titleImage: "", video: "", music: "", lyrics: [] },
  
   









   // READY TO ADD INFORMATION HERE
{
  title: "Old Ways",
  slug: "oldways",
  standardNumber: "5.C.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "",
  music: "",
  lyrics: [],
},
  // READY TO ADD INFORMATION HERE
{
  title: "General Assembly",
  slug: "generalassembly",
  standardNumber: "5.C&G.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "",
  music: "",
  lyrics: [],
},
// READY TO ADD INFORMATION HERE
{
  title: "Benjamin Franklin",
  slug: "benjaminfranklin",
  standardNumber: "5.C&G.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "",
  music: "",
  lyrics: [],
},
// READY TO ADD INFORMATION HERE
{
  title: "The Articles of Confederation",
  slug: "thearticles",
  standardNumber: "5.C&G.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "",
  music: "",
  lyrics: [],
},
// READY TO ADD INFORMATION HERE
{
  title: "Abraham Lincoln",
  slug: "abrahamlincoln",
  standardNumber: "5.C&G.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "",
  music: "",
  lyrics: [],
},
  // READY TO ADD INFORMATION HERE
{
  title: "The Declaration",
  slug: "thedeclaration",
  standardNumber: "5.C&G.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "",
  music: "",
  lyrics: [],
},
// READY TO ADD INFORMATION HERE
{
  title: "The Constitution",
  slug: "theconstitution",
  standardNumber: "5.C&G.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftheconstitutionvideo2025.mp4?alt=media&token=60be23b0-6432-4d5b-8503-6a99b6380b31",
  music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftheconstitution2025song.mp3?alt=media&token=10bf0430-7e96-494d-944c-7bbbe1f81354",
  lyrics: ["(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 1)",
"The Constitution builds our government, step by step, you know it’s true!",
"It gives us leaders like the president, Congress, and the courts we use.",
"Each state has its own set of laws to guide its people every day,",
"but the U.S. Constitution is the highest, it leads the way!",
"In 1787, the framers made their plan, they made their plan.",
"George Washington, Ben Franklin, and others shaped this land.",
"They added amendments to protect our rights, so we’d be free.",
"And the government must follow them—it’s the law for you and me!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 2)",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"Added in 1791 to help our freedoms grow!",
"Added in 1791 to help our freedoms grow!",
"Thousands of changes were proposed, but only 27 were passed.",
"Thousands of changes were proposed, but only 27 were passed.",
"The Constitution stands the test of time, its strength will always last!",
"The Constitution stands the test of time, its strength will always last!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"© Smart Board Learning, LLC. All rights reserved.",],
},
// READY TO ADD INFORMATION HERE
  {
    title: "Cash Crop",
    slug: "cashcrop",
    standardNumber: "5.E.1",
    description: "",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
{
  title: "Trail of Tears",
  slug: "trailoftears",
  standardNumber: "5.G.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "",
  music: "",
  lyrics: [],
},
// READY TO ADD INFORMATION HERE
{
  title: "Location",
  slug: "location",
  standardNumber: "5.G.1",
  description: "",
  gameType: "multipleChoice",
  titleImage: "",
  video: "",
  music: "",
  lyrics: [],
},
  // READY TO ADD INFORMATION HERE
  {
    title: "Countries Explored",
    slug: "countriesexplored",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "Charter",
    slug: "charter",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "Believe",
    slug: "believe",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "Sides",
    slug: "sides",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "Civil War Causes",
    slug: "civilwarcauses",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "Looking For",
    slug: "lookingfor",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "The Arrival",
    slug: "thearrival",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "First Five",
    slug: "firstfive",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "America Grew",
    slug: "americagrew",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },
  // READY TO ADD INFORMATION HERE
  {
    title: "Settlers Moving",
    slug: "settlersmoving",
    standardNumber: "5.H.1",
    description: "History – The student will apply history and social science skills to explain how communities honor local and national traditions and recognize designated Virginia holidays.",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: [],
  },

];
export default topics;